/* eslint-disable guard-for-in */

import {
  CHEIF_ACCESS_MAP,
  NullishValues,
  OS_DROPDOWN_KEYS,
  TRANSFER_OS_DROPDOWN_KEYS,
} from "../constant";
// import IntroductionForm from "../services/api/introductionForm";

/* eslint-disable no-restricted-syntax */
export const notNull = (val) => {
  if (!val || ["null", "undefined"].includes(val)) {
    return "NA";
  }
  return val;
};

/* eslint-disable no-restricted-syntax */
export const osNotNull = (val, skip = false) => {
  if (!val || ["null", "undefined"].includes(val)) {
    return "";
  }
  return skip ? val : `${val}/`;
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const flattenObj = (ob) => {
  const result = {};
  for (const i in ob) {
    if (typeof ob[i] === "object" && !Array.isArray(ob[i])) {
      const temp = flattenObj(ob[i]);
      for (const j in temp) {
        result[`${i}.${j}`] = temp[j];
      }
    } else {
      result[i] = ob[i];
    }
  }
  return result;
};

export const formDataToObject = (rawFormData) =>
  [...rawFormData].reduce(
    (acc, [key, value]) => Object.assign(acc, value ? { [key]: value } : {}),
    {},
  );

export const hasPermissionForAction = (item) => Boolean(item?.actionable);

export const isEmptyObj = (obj) => Boolean(!obj || !Object.keys(obj).length);

export const isOSKey = (key) => OS_DROPDOWN_KEYS.includes(key);

export const isTransferOSKey = (key) => TRANSFER_OS_DROPDOWN_KEYS.includes(key);

export const debounce = (func) => {
  let timer;

  // eslint-disable-next-line func-names
  return function (...args) {
    const context = this;

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 500);
  };
};

export const createArrayByLen = (len) => new Array(len ?? 1).fill(0);

// export const NextChiefApiMapper = {
//   [CHEIF_ACCESS_MAP.districtSI]: IntroductionForm.getAllBlocks,
//   [CHEIF_ACCESS_MAP.chapterSI]: IntroductionForm.getAllDistricts,
//   [CHEIF_ACCESS_MAP.regionSI]: IntroductionForm.getAllChapters,
//   [CHEIF_ACCESS_MAP.zoneSI]: IntroductionForm.getAllRegions,
//   [CHEIF_ACCESS_MAP.areaSI]: IntroductionForm.getAllZones,
// };

export const NextChiefNameMapper = {
  [CHEIF_ACCESS_MAP.districtSI]: "Block",
  [CHEIF_ACCESS_MAP.chapterSI]: "District",
  [CHEIF_ACCESS_MAP.regionSI]: "Chapter",
  [CHEIF_ACCESS_MAP.zoneSI]: "Region",
  [CHEIF_ACCESS_MAP.clusterSI]: "Zone",
  [CHEIF_ACCESS_MAP.areaSI]: "Cluster",
};

export const NextChiefKeyNameIdMapper = {
  areaId: "clusterId",
  clusterId: "zoneId",
  zoneId: "regionId",
  regionId: "chapterId",
  chapterId: "districtId",
  districtId: "blockId",
  blockId: "memberId",
};

export const buildArray = (len) => Array.from({ length: len }, (_, i) => i + 1);

export const toLowerCase = (str) => (str ? str.toLowerCase() : "");
export const toUpperCase = (str) => (str ? str.toUpperCase() : "");
export const toCapitalize = (str) =>
  str ? toUpperCase(str[0]) + toLowerCase(str.slice(1)) : "";

// helper funstions
export const convertToId = (str) => `${toLowerCase(str)}Id`;
export const convertToName = (str) => toUpperCase(str.split("Id")[0]);

export const removeNullishValue = (value) => !NullishValues.includes(value);

export const runAfterDelay = (func, delay = 1000) =>
  setTimeout(() => func(), delay);
